<template>
    <section class="reserve-form">
        <v-container>
         <v-form v-model="valid" @submit.prevent  >
          <v-row>
           <v-col
           :cols="12"
           :sm="6"
           :md="4"
           >
              <div>
                <v-text-field :label="$t('formes.labels.name')" :rules="rules" hide-details="auto"
                :counter="20" prepend-icon="fa fa-user"
                required
                ></v-text-field>
            </div>
           </v-col>
           <v-col
           :cols="12"
           :sm="6"
           :md="4"
           >
           <v-text-field type="tel" :label="$t('formes.labels.phone')" :rules="rules" hide-details="auto"
            prepend-icon="fa fa-phone" ></v-text-field>
           </v-col>
           <v-col
           :cols="12"
           :sm="6"
           :md="4"
           >
            <v-menu
        v-model="menu2Date"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            :label="$t('formes.labels.date')"
            prepend-icon="fa fa-calendar-plus-o"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="date" @input="menu2Date = false"></v-date-picker>
      </v-menu>
           </v-col>
           <v-col
           :cols="12"
           :sm="6"
           :md="4"
           >
           <v-menu
        ref="menu"
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="time"
            :label="$t('formes.labels.time')"
            prepend-icon="fa fa-clock-o"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="menu2"
          v-model="time"
          full-width
          @click:minute="$refs.menu.save(time)"
        ></v-time-picker>
      </v-menu>
           </v-col>
           <v-col
           :cols="12"
           :sm="6"
           :md="4"
           >
           <v-select :items="numPeapel" v-model="peaple" :label="$t('formes.labels.peapel')" 
            hide-details="auto" prepend-icon="fa fa-users"></v-select>
           </v-col>
           <v-col
           :cols="12"
           :sm="6"
           :md="4"
           >
          <v-select :items="branch"  :label="$t('formes.labels.branch')"  hide-details="auto"
           prepend-icon="fa fa-bank" ></v-select>
           </v-col>
          </v-row>
          <v-btn
           color="green" class="mt-4" 
           block dark
           :loading="false"
           :ripple="true"
           type="submit"
           >{{$t("reserve.reserveNow")}}</v-btn>
          </v-form>
        </v-container>
    </section>
</template>

<script>
export default {
    name:'reserve-form',
    data() {
        return {
            ReserveData:{

            },
            numPeapel:[1,2,3,4,5,6,7,8,9,10]
            ,
            rules: [
                    value => !!value || 'Required.',
                    value => (value && value.length >= 3) || 'Min 3 characters',
            ],
            date: new Date().toISOString().substr(0, 10),
            menuDate: false,
            modalDate: false,
            menu2Date: false,
            time: '10:00',
            menu2: false,
            modal2: false,
            valid:true,
            peaple:1,
            branch:['erich','errachidia']
        }
    },
}
</script>